(() => {
  const SELECTOR = '[data-saa-state-carousel]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bindCarousel(shell) {
    if (!shell || shell.dataset.saaCarouselBound === 'true') return;

    const rail = shell.querySelector('[data-saa-state-rail]');
    const previous = shell.querySelector('[data-saa-rail-previous]');
    const next = shell.querySelector('[data-saa-rail-next]');
    if (!rail || !previous || !next) return;

    shell.dataset.saaCarouselBound = 'true';
    let frame = null;

    const update = () => {
      frame = null;
      const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const hasOverflow = maximum > 6;
      shell.dataset.carouselReady = hasOverflow ? 'true' : 'false';
      previous.disabled = !hasOverflow || rail.scrollLeft <= 6;
      next.disabled = !hasOverflow || rail.scrollLeft >= maximum - 6;
    };

    const scheduleUpdate = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(update);
    };

    const scrollStep = () => {
      const card = rail.querySelector('.saa-home__state-card');
      if (!card) return Math.max(320, rail.clientWidth * 0.75);

      const styles = window.getComputedStyle(rail);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const cardWidth = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.floor(rail.clientWidth / cardWidth));
      return cardWidth * Math.max(1, visibleCards - 1);
    };

    const move = (direction) => {
      rail.scrollBy({
        left: scrollStep() * direction,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(rail);
      shell._saaResizeObserver = observer;
    }

    update();
  }

  function initialize(root = document) {
    if (root.matches?.(SELECTOR)) bindCarousel(root);
    root.querySelectorAll?.(SELECTOR).forEach(bindCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
